package com.eladfinish.bible.contest.screens.randomVerse.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.FIVE_SPACES
import com.eladfinish.bible.contest.data.ExpressionReferences
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.extensions.convertToDataClass
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.models.ClickableArea
import com.eladfinish.bible.contest.models.ClickableTextData
import com.eladfinish.bible.contest.screens.randomVerse.RandomVerseRepository
import com.eladfinish.bible.contest.tehilim
import com.eladfinish.bible.contest.yechezkel
import com.eladfinish.bible.contest.yeshaaya
import com.eladfinish.bible.contest.yirmeyah
import dev.icerock.moko.resources.desc.desc

data class SubTopicsData(
    val title: String,
    val jsonTopics: String,
)

class ShowSubTopicsUseCase(
    private val stringResolver: StringResolver,
) {

    fun shouldShowSubTopics(book: String): Boolean =
        book in listOf(
            SharedRes.strings.yeshaaya.desc(),
            SharedRes.strings.yirmeyah.desc(),
            SharedRes.strings.yechezkel.desc(),
            SharedRes.strings.tehilim.desc(),
        ).map { stringResolver.resolveString(it) }

    fun bookToSubTopicsData(book: String): Pair<String, String> =
        when (book) {
            stringResolver.resolveString(SharedRes.strings.yeshaaya.desc()) -> "משאות ישעיהו" to RandomVerseRepository.yeshaaya_nations_prophecies
            stringResolver.resolveString(SharedRes.strings.yirmeyah.desc()) -> "אומות שמתנבא עליהן ירמיהו" to RandomVerseRepository.yirmeyah_nations_prophecies
            stringResolver.resolveString(SharedRes.strings.yechezkel.desc()) -> "אומות שמתנבא עליהן יחזקאל" to RandomVerseRepository.yechezkel_nations_prophecies
            stringResolver.resolveString(SharedRes.strings.tehilim.desc()) -> "מחברי המזמורים" to RandomVerseRepository.tehilim_authors
            else -> throw IllegalArgumentException("Illegal book $book, doesn't have sub-topics")
        }

    fun showSubTopicsInBook(
        data: SubTopicsData,
        currentChapter: Int,
        currentPasuk: Int,
        onCorrectChapter: (Boolean) -> Unit,
    ): ClickableTextData {
        val (title, jsonString) = data
        val items = mutableListOf<String>()
        var actualName = ""
        val topics = jsonString.convertToDataClass<List<ExpressionReferences>>()
        for (expressionReferences in topics) {
            var isCorrect = false
            var name = expressionReferences.name
            // if there is an underscore in either key or value, replace it with NO_BREAK_SPACE
            // (as in bnei_amon => bnei amon)
            name = name.replaceRegex(regex = "_", replacement = StringConstants.NO_BREAK_SPACE)
            // (as in paroh|mitzraim => paroh/mitzraim)
            name = name.replaceRegex(regex = "\\|", replacement = "/")
            items.add(name)
            val locations = expressionReferences.locations
            if (locations == null) {
                val chaptersIntegers = expressionReferences.chapters
                if (chaptersIntegers?.contains(currentChapter) == true) {
                    isCorrect = true
                }
            } else {
                //if the actual nation has not yet been found, keep searching
                if (actualName.isEmpty()) {
                    for (i in locations.indices) {
                        val (chapter, versesList) = locations[i]
                        if (chapter == currentChapter) {
                            if (versesList.isNullOrEmpty()) {
                                isCorrect = true
                            } else {
                                for (list in versesList) {
                                    val start = list[0]
                                    val end: Int = if (list.size == 1) {
                                        start
                                    } else {
                                        list[1]
                                    }
                                    if (currentPasuk in start..end) {
                                        isCorrect = true
                                        break
                                    }
                                }
                            }
                        }
                        if (isCorrect) {
                            break
                        }
                    }
                }
            }
            // if the actual nation was found, store the name of the found nation
            if (isCorrect) {
                actualName = name
            }
        }

        val sb = StringBuilder()
        val clickableAreas = mutableListOf<ClickableArea>()

        if (actualName.isNotEmpty()) {

            sb.append(title).append(":") //.append(StringConstants.FIVE_SPACES)
                .append("\n")

            for (item in items) {
                sb.append(item)
                clickableAreas.add(
                    ClickableArea(
                        start = sb.length - item.length,
                        end = sb.length,
                        name = {
                            onCorrectChapter(item == actualName)
                        }
                    )
                )
                sb.append(FIVE_SPACES)
            }
            sb.append("\n")
        }

        return ClickableTextData(
            text = sb.toString(),
            clickableAreas = clickableAreas,
        )
    }

}
